import {
  AddAPhotoRounded,
  CheckCircleOutlineOutlined,
  ClearRounded,
  ErrorOutlineOutlined,
  ErrorRounded,
  ImageRounded,
  SendRounded,
} from "@mui/icons-material";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import TextFieldCustom from "../../component/textFieldCustom";
import SelectCustom from "../../component/selectCustom";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Api from "../../api/RestApi.json";

export default function KomponenCard(params) {
  const goTo = useNavigate();

  const [file, setFile] = React.useState(null);
  const [lastFile, setLastFile] = React.useState(
    params.image?.nama ? Api.src + "/" + params.image?.nama : null
  );
  const [deskripsi, setDeskripsi] = React.useState(
    params.data?.deskripsi || ""
  );
  const [susunan, setSusunan] = React.useState(params.data?.susunan || "row");
  const handleImagesUpload = (e) => {
    setFile(e.target.files[0]);
    setLastFile(null);
  };
  const [save, setSave] = React.useState(false);
  const [errorSave, setErrorSave] = React.useState(false);
  const [uploadComplete, setUploadComplete] = React.useState(false);
  const [uploadProgress, setUploadProgress] = React.useState(0);
  const [uploadError, setUploadError] = React.useState(null);
  const [deleteStatus, setDeleteStatus] = React.useState(null);

  const deletePost = async (id) => {
    setUploadComplete(false);
    setUploadError(null);
    setDeleteStatus(null);

    try {
      var response = "";
      response = await axios.delete(Api.file + "/" + id);
      if (response !== "") {
        setDeleteStatus("Gambar Lama Berhasil Dihapus");
      }
    } catch (error) {
      console.error("Error delete file:", error);
      setDeleteStatus("File gagal dihapus. Tolong Muat Ulang Halaman.");
      goTo(0);
    }
  };

  const storePost = async (event) => {
    event.preventDefault();
    setSave(false);
    setErrorSave(false);
    setUploadProgress(0);
    setUploadComplete(false);
    setUploadError(null);
    setDeleteStatus(null);

    if (lastFile == null && params.image?.id != null) {
      deletePost(params.image.id);
    }

    // console.log("deskripsi: ", deskripsi == "");
    var des = "";
    if (deskripsi == "") {
      des = "-";
    } else {
      des = deskripsi;
    }
    const formData = {
      id: params.id,
      nama: params.title,
      deskripsi: des,
      susunan: susunan,
    };

    const formFile = new FormData();
    if (file) {
      const nameFile = Date.now() + "_" + params.title + "_" + file.name;
      formFile.append("id_foreign", "-" + params.id);
      formFile.append("kategori", params.title);
      formFile.append("file", file, nameFile);
      formFile.append("tipe", "Image");
      formFile.append("ukuran", file.size);
    }

    var responseData = null;

    try {
      if (params.data) {
        responseData = await axios.put(
          Api.komponen + "/" + params.id,
          formData
        );
      } else {
        responseData = await axios.post(Api.komponen, formData);
      }
      setSave(true);
    } catch (error) {
      console.error("Error add Data: ", error);
      setErrorSave(true);
    }
    if (file != null) {
      try {
        var response = "";
        response = await axios.post(Api.file, formFile, {
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setUploadProgress(percentCompleted);
          },
        });
        setUploadComplete(true);
        // goTo("/potensi");
        goTo(0);
      } catch (error) {
        console.error("Error uploading file:", error);
        setUploadError("File gagal di Upload. Tolong ulangi kembali.");
      }
    }
  };

  return (
    <Box padding={2} bgcolor={"white"} borderRadius={4}>
      <Grid
        container
        direction={"column"}
        spacing={2}
        padding={2}
        alignItems={"start"}
      >
        <Grid size={12}>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Typography variant="h3" fontWeight={"bold"} align="left">
              {params.title}
            </Typography>
            <Button
              variant="contained"
              component="label"
              color="primary"
              startIcon={<AddAPhotoRounded />}
            >
              Pilih Gambar
              <input
                type="file"
                accept="image/*"
                hidden
                onChange={handleImagesUpload}
              />
            </Button>
          </Stack>
        </Grid>
        <Grid size={12}>
          {file ? (
            <Box
              minHeight={"30vh"}
              padding={2}
              bgcolor={"white"}
              boxShadow={2}
              border={"1px solid grey"}
              borderRadius={4}
              alignContent={"center"}
            >
              <Box justifySelf={"right"}>
                <IconButton
                  color="default"
                  fontWeight={"bold"}
                  children={
                    <ClearRounded
                      color="inherit"
                      alignmentBaseline="baseline"
                    />
                  }
                  onClick={(e) => setFile(null)}
                />
              </Box>
              <Box
                component="img"
                src={URL.createObjectURL(file)}
                alt="Preview Thumbnail"
                style={{
                  maxWidth: "100%",
                  maxHeight: "50vh",
                }}
              />
            </Box>
          ) : lastFile ? (
            <Box
              minHeight={"30vh"}
              padding={1}
              bgcolor={"white"}
              boxShadow={2}
              border={"1px solid grey"}
              borderRadius={4}
              alignContent={"center"}
            >
              <Box justifySelf={"right"}>
                <IconButton
                  color="default"
                  fontWeight={"bold"}
                  children={
                    <ClearRounded
                      color="inherit"
                      alignmentBaseline="baseline"
                    />
                  }
                  onClick={(e) => setLastFile(null)}
                />
              </Box>
              <Box
                component="img"
                src={lastFile}
                alt="lastFile"
                style={{
                  maxWidth: "100%",
                  maxHeight: "50vh",
                }}
              />
            </Box>
          ) : (
            <Box
              minHeight={"30vh"}
              width={"100%"}
              border={"2px dashed grey"}
              borderRadius={4}
              alignContent={"center"}
            >
              <ImageRounded fontSize="large" />
            </Box>
          )}
        </Grid>
        <Grid size={12}>
          <form onSubmit={storePost}>
            <Grid container spacing={2}>
              <Grid size={12}>
                <TextFieldCustom
                  title="Deskripsi"
                  name="deskripsi"
                  id="deskripsi"
                  value={deskripsi}
                  onChange={(e) => setDeskripsi(e.target.value)}
                  type="text"
                  label="Deskripsi"
                  required={false}
                  multiline={true}
                />
              </Grid>
              <Grid size={12}>
                <SelectCustom
                  title="Susunan"
                  name="susunan"
                  id="susunan"
                  value={susunan}
                  onChange={(e) => setSusunan(e.target.value)}
                  label="Susunan"
                  options={[
                    { value: "row", label: "Horizontal" },
                    { value: "column", label: "Vertikal" },
                    { value: "row-reverse", label: "Horizontal-Terbalik" },
                    { value: "column-reverse", label: "Vertikal-Terbalik" },
                  ]}
                  required={true}
                />
              </Grid>
              <Grid size={12}>
                <Box justifySelf={"center"} mt={4}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="success"
                    size="large"
                    startIcon={<SendRounded />}
                  >
                    Kirim
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Grid>

        <Grid size={12}>
          {save && (
            <Box flex={1} justifySelf={"center"}>
              <Typography
                variant="body2"
                color="success.main"
                sx={{ display: "flex", alignItems: "center" }}
              >
                <CheckCircleOutlineOutlined sx={{ mr: 1 }} />
                Data berhasil Tersimpan
              </Typography>
            </Box>
          )}

          {errorSave && (
            <Box flex={1} justifySelf={"center"}>
              <Typography
                variant="body2"
                color="error.main"
                sx={{ display: "flex", alignItems: "center" }}
              >
                <ErrorRounded sx={{ mr: 1 }} />
                Data gagal Tersimpan! Pastikan Deskripsi Diisi atau Kosong! Silahkan Muat Ulang dan isi data kembali.
              </Typography>
            </Box>
          )}

          {uploadProgress > 0 && (
            <Typography variant="body2" color="textSecondary">
              Upload Progress: {uploadProgress}%
            </Typography>
          )}
          {uploadComplete && (
            <Box flex={1} justifySelf={"center"}>
              <Typography
                variant="body2"
                color="success.main"
                sx={{ display: "flex", alignItems: "center" }}
              >
                Upload Complete <CheckCircleOutlineOutlined sx={{ ml: 1 }} />
              </Typography>
            </Box>
          )}
          {uploadError && (
            <Box flex={1} justifySelf={"center"}>
              <Typography
                variant="body2"
                color="error"
                sx={{ display: "flex", alignItems: "center" }}
              >
                <ErrorOutlineOutlined sx={{ mr: 1 }} />
                {uploadError}
              </Typography>
            </Box>
          )}
          {/* {deleteStatus && (
            <Box flex={1} justifySelf={"center"}>
            <Typography
              variant="body2"
              color="error.main"
              sx={{ display: "flex", alignItems: "center" }}
            >
              <DeleteRounded sx={{ ml: 1 }} /> {deleteStatus}
            </Typography>
            </Box>
          )} */}
        </Grid>
      </Grid>
    </Box>
  );
}
